import { Injectable, TemplateRef } from '@angular/core';
import { SizeItems, StatusItems } from '@core/types/base.types';
import { generateGUID } from '@core/utils/misc.util';
import { NbDialogConfig, NbDialogRef, NbDialogService } from '@nebular/theme';

@Injectable({ providedIn: 'root' })
export class ModalService {
	private modalRefs: DialogRef[] = [];

	constructor(private dialogService: NbDialogService) {}

	open(content: TemplateRef<any>, config: ModalParams, options?: Partial<NbDialogConfig>) {
		const modalRef = this.dialogService.open(content, { ...options, context: config });
		modalRef['guid'] = generateGUID();
		this.modalRefs.push(modalRef);
		modalRef.onClose.subscribe(
			reason => (this.modalRefs = this.modalRefs.filter(f => f.guid !== modalRef['guid']))
		);
		return modalRef;
	}
	closeAll(result?: any): void {
		this.modalRefs.forEach(modal => modal.close(result));
		this.modalRefs = [];
	}
	closeLast(result?: any): void {
		this.modalRefs[this.modalRefs.length - 1].close(result);
		this.modalRefs.pop();
	}
	isOpen() {
		return this.modalRefs.length;
	}
}

type DialogRef = NbDialogRef<any> & {
	guid?: string;
};
export interface ModalParams {
	title?: string;
	confirm?: boolean;
	noClose?: boolean;
	buttons?: ModalButton[];
	icon?: string;
	confirmText?: string;
	headerClass?: string;
	data?: any;
}
export interface ModalButton {
	id?: string;
	class?: string;
	text?: string;
	outline?: boolean;
	size?: keyof SizeItems;
	status?: keyof StatusItems;
}
export interface ModalSubmit<T = any> {
	data?: T;
	msg?: string;
	close?: boolean;
}
